import type { Copy } from "../types";

export const no: Copy = {
    seo: {
      title: "Bilalderkalkulator | Sjekk kjøretøyets alder etter år og måned",
      description:
        "Sjekk alderen på et kjøretøy fra produksjonsår og valgfri måned. Se år, måneder, dager, totalt antall dager og milepæler.",
      keywords: [
        "bilalderkalkulator",
        "kjøretøy alder kalkulator",
        "produksjonsår bil",
        "produksjonsmåned kjøretøy",
        "hvor gammel er bilen min",
        "bilalder etter år",
        "sjekk kjøretøyets alder",
        "RC alder kalkulator",
        "bilalder etter måned",
        "kjøretøy dato kalkulator",
        "mParivahan alternativ",
        "Parivahan alternativ",
        "RTO kjøretøy alder kalkulator",
        "sjekk registreringsalder",
        "kjøretøyets registreringsalder",
      ],
      faq: [
        {
          question: "Hva gjør denne kalkulatoren?",
          answer:
            "Den beregner nøyaktig alder for et kjøretøy fra valgt produksjonsår og valgfri måned, og viser år, måneder, dager og milepæler.",
        },
        {
          question: "Hvorfor finnes det en valgfri måned?",
          answer:
            "Måneden gir en mer presis aldersberegning. Hvis du hopper over den, bruker appen januar i valgt år.",
        },
        {
          question: "Kan jeg velge et fremtidig år eller en fremtidig måned?",
          answer:
            "Nei. Fremtidige år blokkeres, og fremtidige måneder deaktiveres når valgt år er inneværende år.",
        },
      ],
    },
    headerTagline: "Kjøretøyverktøy",
    headerTitle: "Bilalderkalkulator",
    reset: "Tilbakestill",
    switchToLight: "Bytt til lys modus",
    switchToDark: "Bytt til mørk modus",
    languageLabel: "Språk",
    languageEnglish: "Engelsk",
    languageHindi: "Hindi",
    heroEyebrow: "Bilalder, tydelig",
    heroTitle: "Et enkelt datoverktøy for kjøretøyets alder.",
    heroDescription:
      "Velg produksjonsår. Legg bare til måned hvis du vil ha et mer presist aldersresultat.",
    yearSelectLabel: "Produksjonsår",
    monthSelectLabel: "Produksjonsmåned",
    includeMonthLabel: "Ta med spesifikk måned for bedre presisjon",
    includeMonthNote:
      "Hvis du ikke tar med en måned, brukes januar i beregningen.",
    yearOnlyBadge: "Kun år",
    yearMonthBadge: "År + måned",
    yearPlaceholder: "Velg år",
    monthPlaceholder: "Velg måned",
    inputTitle: "Produksjonsår",
    inputLabel: "Produksjonsår",
    blockedDateNote: "Fremtidige år er blokkert.",
    result: "Resultat",
    vehicleAgeLead: "Kjøretøyet ditt er",
    asOfToday: "Per i dag",
    years: "År",
    months: "Måneder",
    days: "Dager",
    totalDays: (count) => `${count.toLocaleString("nb-NO")} dager totalt`,
    ageLabels: {
      almostNew: "Nesten nytt",
      modern: "Moderne",
      mature: "Modent",
      classic: "Klassisk",
    },
    estimatedValue: {
      high: "Høyt videresalgspotensial",
      healthy: "God verdioppbevaring",
      moderate: "Moderat verdifall",
      collector: "Samlerinteressen kan øke",
    },
    maintenanceTitle: "Vedlikehold",
    maintenance: {
      routine: "Rutineservice og OEM-vedlikehold",
      watch: "Følg med på bremser, væsker og dekk",
      plan: "Planlegg slitedeler og inspeksjoner",
      specialized: "Spesialisert vedlikehold blir verdifullt",
    },
    registrationTitle: "Registrering",
    registration: {
      collector: "Kan kvalifisere for samlerlignende behandling i enkelte regioner",
      classic: "Klassisk kjøretøyregistrering kan gjelde i enkelte regioner",
      standard: "Forvent standard fornyelser og regionale kontroller",
      regular: "Vanlig registrering gjelder som regel",
    },
    upcomingMilestoneTitle: "Kommende milepæl",
    milestoneTimelineTitle: "Milepælslinje",
    milestoneRemaining: ({ label, days }) => `${label} om ${days.toLocaleString("nb-NO")} dager`,
    reached: "Nådd",
    upcoming: "Kommende",
    allMilestonesReachedTitle: "Alle oppførte milepæler er nådd",
    allMilestonesReachedBody:
      "Dette kjøretøyet har passert milepælsområdet som vises i appen.",
    copySummary: "Kopier sammendrag",
    shareResult: "Del resultat",
    resetMessage: "Kalkulatoren er tilbakestilt",
    summaryCopied: "Sammendrag kopiert til utklippstavlen",
    clipboardFailed: "Tilgang til utklippstavlen mislyktes",
    emptyTitle: "Velg et produksjonsår for å få hele oversikten",
    emptyDescription:
      "Når et år er valgt, ser du nøyaktig alder, totalt antall dager, vedlikeholdsnotater, klassikerstatus og milepæler.",
    shareTitle: "Bilalderkalkulator",
    summary: ({ label, years, months, days, asOf }) =>
      `Bilen min ble produsert i ${label} og er ${years} år, ${months} måneder og ${days} dager gammel per ${asOf}.`,
    milestones: {
      1: { label: "Første år", note: "Nyttig for garanti- og serviceplanlegging." },
      3: { label: "Tre år", note: "Et vanlig tidspunkt for videresalg og verdiendringer." },
      5: { label: "Fem år", note: "God tid for mer detaljert vedlikeholdsbudsjettering." },
      10: { label: "Ti år", note: "Aldrende komponenter trenger ekstra oppmerksomhet." },
      15: { label: "Femten år", note: "Mange regioner begynner klassikerbehandling her." },
      25: { label: "Tjuefem år", note: "Samler- og importinteresse kan øke i noen markeder." },
    },
  };
